import { Button, Col, Divider, Form, FormInstance, Input, Row, Select, message } from "antd";
import { FC } from "react"
import { APP_COLOR, CMARKER_TYPES } from "../../../constant";
import { SwapOutlined } from "@ant-design/icons";
import { CMarkerType } from "../../../constant/type";
import { MapRef } from "react-map-gl";
import { createGpx } from "../../../services";
import { handleCallListVectorRoad } from "../helper";

interface PProps {
    setIMarkerType: React.Dispatch<React.SetStateAction<string>>,
    formSearchRoute: FormInstance<any>,
    formCreateGpx: FormInstance<any>,
    kindOfWayDirection: {
        value: string;
        label: string;
    }[],
    swapMarkers: () => void,
    handleCopyClick: (text: any) => void,
    setMarkersStart: (value: React.SetStateAction<CMarkerType | undefined>) => void,
    mapRef: React.RefObject<MapRef>,
    setMarkersEnd: React.Dispatch<React.SetStateAction<CMarkerType | undefined>>,
    setOptionVectorRoadId: React.Dispatch<any>,
    setPrevLine: React.Dispatch<any>
}

export const CreateGpx: FC<PProps> = ({
    setIMarkerType,
    formSearchRoute,
    formCreateGpx,
    kindOfWayDirection,
    swapMarkers,
    handleCopyClick,
    setMarkersStart,
    mapRef,
    setMarkersEnd,
    setOptionVectorRoadId,
    setPrevLine
}) => {
    const handleCreateGpx = (values: any) => {
        const data = {
            vectorRoadId: `${values.vectorRoadId}_${values.wayDirection}`,
            wayDirection: values.wayDirection,
            vectorGeometry: values.vectorGeometry,
            maxDistance: values.maxDistance || 5,
            gpxNormalStep: values.gpxNormalStep || 100,
        }
        createGpx(data).then((data) => {
            message.success('Tạo GPX thành công');
            window.open(`${data.data.download_link}`);
            handleCallListVectorRoad(setOptionVectorRoadId, setPrevLine);

        }).catch((err) => {
            message.error('Tạo GPX thất bại');
            console.log('err', err);
        })
    }
    const handleKeyUpStart = (event: any) => {
        if (event.keyCode === 13) {
            const srcLocation = formSearchRoute.getFieldValue('srcLocation');
            const regex = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
            if (regex.test(srcLocation)) {
                formSearchRoute.setFields([
                    {
                        name: 'srcLocation',
                        errors: []
                    }
                ])
                const [lat, lon] = formSearchRoute.getFieldValue('srcLocation').split(',').map(parseFloat);
                console.log(lat, lon);
                setMarkersStart({
                    lat,
                    lon,
                    type: CMARKER_TYPES.start
                })
                mapRef!.current?.flyTo({ center: [lon, lat], animate: false });
            } else formSearchRoute.setFields([
                {
                    name: 'srcLocation',
                    errors: ['Vui lòng nhập đúng định dạng']
                }
            ])
            console.log(formSearchRoute.getFieldValue('srcLocation'));

        }
    }
    const handleKeyUpEnd = (event: any) => {
        if (event.keyCode === 13) {
            const dstLocation = formSearchRoute.getFieldValue('dstLocation');
            const regex = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
            if (regex.test(dstLocation)) {
                const [lat, lon] = dstLocation.split(',').map(parseFloat);
                console.log(lat, lon);
                formSearchRoute.setFields([
                    {
                        name: 'dstLocation',
                        errors: []
                    }
                ])
                setMarkersEnd({
                    lat,
                    lon,
                    type: CMARKER_TYPES.end
                })
                mapRef!.current?.flyTo({ center: [lon, lat], animate: false });
            }
            else formSearchRoute.setFields([
                {
                    name: 'dstLocation',
                    errors: ['Vui lòng nhập đúng định dạng']
                }
            ])

        }
    }
    return <div key='line-traffic' className="shadow-boxShadow rounded-lg p-4 bg-white">
        <Form form={formSearchRoute} layout='horizontal'>
            <Row gutter={2}>
                <Col span={18}>
                    <Form.Item required name='srcLocation' >
                        <Input onKeyUp={handleKeyUpStart} allowClear placeholder='Toạ độ start(vĩ độ-lat,kinh độ-lon)' />
                    </Form.Item>
                </Col>
                <Col span={2}>
                    <Button className="bg-base text-white w-24"
                        onClick={() => setIMarkerType(CMARKER_TYPES.start)}>Chọn Start</Button>
                </Col>
            </Row>
            <Row gutter={2}>
                <Col span={18}>
                    <Form.Item required name='dstLocation'>
                        <Input onKeyUp={handleKeyUpEnd} allowClear placeholder='Toạ độ end(vĩ độ-lat,kinh độ-lon)' />
                    </Form.Item>
                </Col>
                <Col span={2}>
                    <Button className="bg-base text-white w-24" onClick={() => setIMarkerType(CMARKER_TYPES.end)}>Chọn End</Button>
                </Col>
            </Row>
            <Row className="-mb-2" gutter={4} >
                <Col span={21}>
                    <Form.Item required label='Bearings' name='bearings' >
                        <Input allowClear placeholder='Bearings' defaultValue={-1} />
                    </Form.Item>
                </Col>
                <Col span={2}>
                    <Button className="bg-base text-white mb-4" onClick={swapMarkers}><SwapOutlined onKeyDown={undefined} /></Button>
                </Col>
            </Row>
            <Divider></Divider>
        </Form>
        <Form onFinish={handleCreateGpx} form={formCreateGpx} layout='vertical'>
            <Form.Item required label='Vector Road Id' name='vectorRoadId' rules={[{ required: true, message: 'Vui lòng nhập Vector Road Id' }]}>
                <Input allowClear placeholder='vectorRoadId' />
            </Form.Item>
            <Form.Item required name='wayDirection' label='Way Direction' rules={[{ required: true, message: 'Vui lòng chọn Way Direction' }]}>
                <Select options={kindOfWayDirection}></Select>
            </Form.Item>
            <Row gutter={4} align={'middle'}>
                <Col span={20}>
                    <Form.Item required name='vectorGeometry' label='Vector Geometry' >
                        <Input allowClear placeholder='Nhập Vector Geometry' disabled />
                    </Form.Item>
                </Col>
                <Col span={2}>
                    <Button
                        onClick={() => handleCopyClick(formCreateGpx.getFieldValue('vectorGeometry'))}
                        className="bg-base text-white -mb-2" >Copy</Button>
                </Col>
            </Row>
            <Row className="-mb-4" gutter={4}>
                <Col span={10}>
                    <Form.Item required name='maxDistance' label='Max Distance' initialValue={5} >
                        <Input allowClear placeholder='maxDistance' />
                    </Form.Item>
                </Col>
                <Col span={10}>
                    <Form.Item required name='gpxNormalStep'
                        label='Gpx Normal Step' initialValue={100} >
                        <Input allowClear placeholder='gpxNormalStep' />
                    </Form.Item>
                </Col>
            </Row>


            <Row gutter={16}>
                <Col span={8}>
                    <Form.Item required name='dstLat'>
                        <Button className="bg-base" type='primary' htmlType='submit' >
                            Hoàn thành
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    </div>
}

